/**
 * Component that shows or hides a child component depending on whether the desired
 * flag exists
 */
import PropTypes from 'prop-types';

const propTypes = {
  flags: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  flagKey: PropTypes.string.isRequired,
  render: PropTypes.func,
  negate: PropTypes.bool,
};

function FlagEnabled({ flags, flagKey, children, render, negate }) {
  let val = flags ? flags[flagKey] : false;
  val = val && Object.prototype.hasOwnProperty.call(val, 'current') ? val.current : val;
  if (negate) {
    val = !val;
  }
  if (val) {
    return render ? render() : children;
  }
  return null;
}

FlagEnabled.propTypes = propTypes;
FlagEnabled.defaultProps = { negate: false };

export default FlagEnabled;
